import React from "react";
import Modal from "@components/_Revamp/Modal";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription/TitleAndDescription";
import { styled } from "@linaria/react";
import { themeDefault } from "src/theme-revamp";

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 24px;
`;
const CustomButton = styled.button<{ filled: boolean }>`
  border: none;
  display: flex;
  justify-content: center;
  font-weight: 600;
  width: 180px;
  height: 52px;
  background: ${(prop) =>
    prop.filled ? themeDefault.colors.primary : themeDefault.colors.white};
  align-items: center;
  text-align: center;
  letter-spacing: 0.08em;
  transition: all 0.2s linear;
  color: ${(prop) =>
    prop.filled ? themeDefault.colors.white : themeDefault.colors.primary};
  cursor: pointer;
  border: 1px solid #883e89;
  border-radius: 100px;
   &:hover {
    background: #883E89;
    color: #FFFFFF;
   }

`;

function DeclarationModal({
  onClose,
  showModal,
  children,
}: {
  onClose: React.MouseEventHandler<HTMLDivElement>,
  showModal: boolean;
  children: React.ClassAttributes<HTMLDivElement>;
}) {
  return (
    <Modal onClose={onClose} show={showModal}>
      {children}
    </Modal>
  );
}

export default DeclarationModal;
